import { Box, Chip } from "@mui/material";
import type { SourcesFilters } from "@/types";
import { buildSourcesChips } from "@/utils/sourcesSidebar.ts";

export default function SourcesChips({ filters, windowDays, onChange }: {
  readonly filters: SourcesFilters;
  readonly windowDays: number | null;
  readonly onChange: (filters: SourcesFilters) => void;
}) {
  const chips = buildSourcesChips(filters, windowDays);
  if (chips.length === 0) return null;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
      {chips.map((chip) => <Chip key={chip.id} size="small" label={chip.label} onDelete={() => onChange(chip.without)} />)}
    </Box>
  );
}
